import { createAppTestIds } from './index';

/**
 * Test IDs for Google integration
 */
export const GOOGLE_TEST_IDS = {
  ...createAppTestIds('google'),
} as const;
